import { render } from "./FreeMap.vue?vue&type=template&id=b1bdf842"
import script from "./FreeMap.vue?vue&type=script&lang=js"
export * from "./FreeMap.vue?vue&type=script&lang=js"

import "./FreeMap.vue?vue&type=style&index=0&id=b1bdf842&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__